import { Component, OnInit } from '@angular/core';
import {
  formatDateTimeStamp,
  isLargeScreen,
} from '../../../../../global.variable';
import { AddEditIdentificationComponent } from '../../../../shared/components/identification/add-edit-identification/add-edit-identification.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { AddEditUserComponent } from '../add-edit-user/add-edit-user.component';
import { UsersService } from '../users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ToasterService } from '../../../../shared/services/toaster.service';

@Component({
  selector: 'gtapp-manage-identification',
  templateUrl: './manage-identification.html',
  styleUrl: './manage-identification.scss',
  standalone: false,
})
export class ManageIdentification implements OnInit {
  largeView: Boolean = isLargeScreen;
  licenseTab: any = {
    tab1: 'Active',
    tab2: 'Expired',
  };

  unLicnesedGuardTableDetails = [
    {
      name: 'full_name',
      header: 'Guard',
      searchKey: 'full_name',
      sortKey: 'full_name',
    },
    {
      name: 'email',
      header: 'Email',
      searchKey: 'email',
      sortKey: 'email',
    },
  ];

  licenceDetailsDesktopTable = this.getTableColumnInfo();

  selectedTab: string = this.licenseTab?.tab1;

  guardIdentificationDataList: any = [];
  previousGuardIdentifications: number = 0;
  pageSizeGuardIdentifications: number = 15;
  pageNumGuardIdentifications: number = 1;
  totalPagesGuardIdentifications: number = 0;
  sortKeyGuardIdentifications: any;
  searchParamsGuardIdentifications: any;

  otherParamsGuardIdentifications: any = {
    apiFiltering: true,
    tableRowStyle: (rowData: any) => {
      return this.selectedTab == this.licenseTab?.tab3
        ? { cursor: 'not-allowed' }
        : {};
    },
  };

  initialTotalCount: number = 0;

  archivedIdentificationsExists: boolean = false;
  showArchived: boolean = false;

  activeCredentials: boolean = true;

  threeMonthCheck: boolean = false;

  selectedUser: any = {};

  constructor(
    private userService: UsersService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    let currentUrlFragment: any = this.route.snapshot.fragment;

    if (!['active', '3month', 'expired'].includes(currentUrlFragment)) {
      currentUrlFragment = 'active';
    }

    switch (currentUrlFragment) {
      case 'active':
        if (sessionStorage.getItem(btoa('userDetailCredentialData'))) {
          this.selectedUser = JSON.parse(
            sessionStorage.getItem(btoa('userDetailCredentialData')) || '{}',
          );
          sessionStorage.removeItem(btoa('userDetailCredentialData'));
        }

        this.changeTab(this.licenseTab?.tab1);
        break;
      case '3month':
        this.threeMonthCheck = true;
        this.changeTab(this.licenseTab?.tab1);
        break;
      case 'expired':
        this.changeTab(this.licenseTab?.tab2);
        break;
    }
  }

  openGuardInfo(guardData: any) {
    if (guardData.id) {
      this.dialogService.open(AddEditUserComponent, {
        data: {
          editUser: true,
          detailData: guardData,
        },
      });
    }
  }
  getAllUserGuardIdentifications() {
    let params: any = { from_manage_cred_page: 1 };
    if (this.threeMonthCheck) {
      const threeMonth = new Date();
      threeMonth.setMonth(threeMonth.getMonth() + 3);
      this.searchParamsGuardIdentifications = {
        ...this.searchParamsGuardIdentifications,
        valid_till__lte: formatDate(
          new Date(threeMonth),
          'yyyy-MM-dd',
          'en_US',
        ),
      };
    }
    if (this.searchParamsGuardIdentifications) {
      params['search_filters'] = JSON.stringify(
        this.searchParamsGuardIdentifications,
      );
    }
    if (this.pageSizeGuardIdentifications) {
      params['rows'] = this.pageSizeGuardIdentifications;
    }
    if (this.previousGuardIdentifications) {
      params['previous'] = this.previousGuardIdentifications;
    }
    if (this.sortKeyGuardIdentifications) {
      params['sort_key'] = this.sortKeyGuardIdentifications;
    }
    if (this.selectedUser?.id) {
      params['assignee_id'] = this.selectedUser?.id;
    }

    if (this.showArchived) {
      params.show_archived = 1;
    } else {
      params[this.activeCredentials ? 'active' : 'expired'] = 1;
    }
    this.userService.listIdentifications(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.guardIdentificationDataList = response?.data;
        if (response?.archived_exists) {
          this.licenseTab['tab3'] = 'Archived';
        }

        this.archivedIdentificationsExists = response?.archived_exists;

        this.otherParamsGuardIdentifications.paginationData = {
          totalRows: response?.total_count,
          previousRows: this.previousGuardIdentifications,
          rows: this.pageSizeGuardIdentifications,
          pageNum: this.pageNumGuardIdentifications,
        };
        this.initialTotalCount = Math.max(
          this.initialTotalCount,
          response?.total_count,
        );
      }

      this.spinnerService.hide();
    });
  }
  onSelectUser(userData: any) {
    this.selectedUser = userData;
    this.resetPaginationAndCallData();
  }
  resetPaginationAndCallData(resetTable = false) {
    this.pageNumGuardIdentifications = 1;
    this.previousGuardIdentifications = 0;
    if (resetTable) {
      this.licenceDetailsDesktopTable = this.getTableColumnInfo();
    }
    this.getAllUserGuardIdentifications();
  }
  sortColumnGuardIdentifications(body: any) {
    this.sortKeyGuardIdentifications = body?.sortList || [];
    this.searchParamsGuardIdentifications = body?.searchParams || {};
    this.resetPaginationAndCallData();
  }
  searchColumnGuardIdentifications(event: any) {
    this.searchParamsGuardIdentifications = event?.searchParams || {};
    this.resetPaginationAndCallData();
  }

  onChangePaginationGuardIdentifications(data: any) {
    this.previousGuardIdentifications = data?.paginationData?.previousRows;
    this.pageNumGuardIdentifications = data?.paginationData?.pageNum;
    this.pageSizeGuardIdentifications = data?.paginationData?.rows;

    this.otherParamsGuardIdentifications.paginationData = {
      ...data?.paginationData,
    };
    this.getAllUserGuardIdentifications();
  }

  changeTab(tab: any) {
    this.selectedTab = tab;
    this.initialTotalCount = 0;

    this.licenceDetailsDesktopTable = this.getTableColumnInfo();
    switch (this.selectedTab) {
      case this.licenseTab?.tab1:
        this.previousGuardIdentifications = 0;
        this.activeCredentials = true;
        this.showArchived = false;
        this.getAllUserGuardIdentifications();
        break;
      case this.licenseTab?.tab2:
        this.showArchived = false;
        this.previousGuardIdentifications = 0;
        this.activeCredentials = false;
        this.getAllUserGuardIdentifications();
        break;
      case this.licenseTab?.tab3:
        this.previousGuardIdentifications = 0;
        // this.activeCredentials = true;
        this.showArchived = true;
        this.getAllUserGuardIdentifications();
        break;
    }
  }
  addNewLicense() {
    const dialogRef = this.dialogService.open(AddEditIdentificationComponent, {
      data: {
        showFrom: 'manageIdentificationPage',
        companyLicense: false,
        selectedUser: this.selectedUser,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getAllUserGuardIdentifications();
      }
    });
  }
  editIdentification(identificationData: any) {
    if (this.showArchived) return;
    const dialogRef = this.dialogService.open(AddEditIdentificationComponent, {
      data: {
        showFrom: 'manageIdentificationPage',
        companyLicense: false,
        selectedIdentification: identificationData,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getAllUserGuardIdentifications();
      }
    });
  }

  getTableColumnInfo() {
    if (this.largeView) {
      const tableItems: any = [
        {
          header: 'User',
          name: 'full_name',
          // searchKey: 'full_name',
          sortKey: 'full_name',
          conditionalColumnDataStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? { color: 'var(--bs-danger)' }
              : {};
          },
        },

        {
          header: 'ID',
          name: 'licence_class',
          searchKey: 'licence_class__name',
          sortKey: 'licence_class__name',
          tableColumnStyle: {
            'white-space': 'pre-line',
          },
          prefixNestedValue: (row: any) => {
            return `${row?.id_type}\n`;
          },

          conditionalPrefixStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? {
                  'color': 'var(--bs-danger)',
                  'font-weight': '700',
                }
              : { 'font-weight': '700' };
          },
          conditionalColumnDataStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? { color: 'var(--bs-danger)' }
              : {};
          },
        },
        {
          header: 'ID Number',
          name: 'id_number',
          conditionalColumnDataStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? { color: 'var(--bs-danger)' }
              : {};
          },
        },

        {
          header: 'State',
          name: 'issuer_state',
          searchKey: 'issuer_state_name',
          sortKey: 'issuer_state_name',
          conditionalColumnDataStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? { color: 'var(--bs-danger)' }
              : {};
          },
        },

        {
          header: 'Expiry',
          name: 'valid_till',
          // dateRangeKey: 'valid_till',
          nestedValue: (row: any) => {
            return formatDateTimeStamp(row?.valid_till, 'd MMM y', 'en');
          },
          conditionalColumnDataStyle: (rowData: any) => {
            return rowData?.expiry_code == 2 &&
              this.selectedTab === this.licenseTab?.tab2
              ? { 'color': 'var(--bs-danger)', 'font-weight': '700' }
              : {};
          },

          sortKey: 'valid_till',
        },
        {
          header: 'Issue Date',
          name: 'issue_date',
          nestedValue: (row: any) => {
            return formatDateTimeStamp(row?.issue_date, 'd MMM y', 'en');
          },

          sortKey: 'issue_date',
        },
      ];
      if (this.selectedTab === this.licenseTab?.tab2) {
        tableItems.push({
          header: '',
          showAction: true,
          actionOptions: [
            {
              actionStyle: {
                'padding': '0.3rem 0.6rem',
                'border': '1px solid var(--bs-danger-bg-subtle)',
                'color': 'var(--bs-danger)',
                'background': 'var(--bs-danger-bg-subtle)',
                'border-radius': '5px',
              },
              role: 'button',

              condition: function (row: any) {
                return {
                  value: 'ARCHIVE',
                  confirm: true,
                  type: 'archive',
                  title: 'Archive',
                };
              },
            },
          ],
        });
      }

      return tableItems;
    }
    return [
      {
        header: 'Guard',
        name: 'full_name',
        // searchKey: 'full_name',
        sortKey: 'full_name',
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        suffixNestedValue: (row: any) => {
          let suffixList: any = [];
          if (row?.issue_date) {
            suffixList.push(
              `\nDate of Issue: ${formatDateTimeStamp(row?.issue_date, 'd MMM y', 'en')}`,
            );
          }
          if (row?.valid_till) {
            suffixList.push(
              `Expiry: ${formatDateTimeStamp(row?.valid_till, 'd MMM y', 'en')}`,
            );
          }
          return suffixList?.join('\n');
        },
        suffixStyle: {
          'font-size': 'small',
          'color': 'var(--bs-secondary)',
        },
      },
      {
        header: 'ID',
        name: 'licence_class',
        searchKey: 'licence_class',
        sortKey: 'licence_class',
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        prefixNestedValue: (row: any) => {
          return `${row?.id_type}\n`;
        },
        prefixStyle: {
          'font-size': 'small',
          'font-weight': '700',
        },
        suffixNestedValue: (row: any) => {
          return `\n${row?.issuer_state} \nID: ${row?.id_number}`;
        },
        suffixStyle: {
          'font-size': 'small',
          'color': 'var(--bs-secondary)',
        },
      },
    ];
  }
  deleteIdentification(credential: any) {
    let params: any = {
      archive: 1,
      credential_owner: 'user',
      from_manage_cred_page: 1,
    };

    this.userService
      .updateIdentification(credential?.id, {}, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.getAllUserGuardIdentifications();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
    // let dialogMsg = 'Archive identification?';
    // const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
    //   data: {
    //     title: 'Archive ID',
    //     btn2Detail: { text: 'Archive', class: 'btn-danger' },
    //     message: dialogMsg,
    //   },
    // });
    // dialogRef.afterClosed().subscribe((value: any) => {
    //   if (value === true) {

    //   }
    // });
  }
}
